module.exports = __webpack_public_path__ + "img/Ranger.9de8bc14.png";